import { reportContentConstants } from '../../_constants';

const initialState = { getSlotListLoading: true, data: '', error: false };

export function getSlotList(state = initialState, action) {

    switch (action.type) {
        case reportContentConstants.REQUEST_SLOT_LIST:
            return {
                getSlotListLoading: true,
                data: '',
                error: false
            };
        case reportContentConstants.RECEIVE_SLOT_LIST:

            return {
                getSlotListLoading: false,
                data: action.getSlotList,
                error: false
            };
        case reportContentConstants.SLOT_LIST_ERROR:
            return {
                getSlotListLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/reportContent/getSlotList.reducer.js